import { FORWARD_SLASH } from '@tn/foundation/utils/constants/common';
import { Values } from 'xstate';

export const StateTypes = {
    account: 'Account',
    cadence: 'Cadence',
    explainer: 'Explainer',
    upsell: 'Upsell',
    pickplan: 'Pick Plan',
    signup: 'AuthN.Sign Up',
    signin: 'AuthN.Sign In',
    payment: 'Payment',
    tier: 'Tier',
} as const;

const baseRoute = '/account';

export const flowRoutes: Record<(typeof StateTypes)[keyof typeof StateTypes], string> = {
    [StateTypes.account]: `${baseRoute}/`,
    [StateTypes.upsell]: FORWARD_SLASH,
    [StateTypes.tier]: `${baseRoute}/tier/`,
    [StateTypes.cadence]: `${baseRoute}/cadence/`,
    [StateTypes.signin]: `${baseRoute}/signin/`,
    [StateTypes.pickplan]: `${baseRoute}/signup/pickplan/`,
    [StateTypes.signup]: `${baseRoute}/signup/createaccount/`,
    [StateTypes.payment]: `${baseRoute}/signup/submitpayment/`,
    [StateTypes.explainer]: `${baseRoute}/signup/explainer/`,
};

export type FlowRoutes = typeof flowRoutes;

export type FlowRouteValues = Values<FlowRoutes>;
